import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import { Link } from "react-router-dom";

import Heading from "../../components/Heading";

import { Grid, Button, IconButton, Snackbar, Card, CardActions, CardContent, Avatar, Typography, Divider, TextField, CircularProgress } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import image from "../../helper/image";


@inject("profileStore", "templateStore", "venueStore")
@observer
class Venues extends Component {
    state = {
        expanded: false,
        openDeleteConfirmationModal: false,
        deletedActId: undefined,
        deletedActName: "",
        openSnackbar: false,
        snackbarMessage: "",
        filterText: "",
        venueCount: 10,
        isSearchMode: false,
        searchResults: [],
        isSearching: false
    };

    constructor(props) {
        super(props);
        this.props.venueStore.resetVenues();
    }

    componentDidMount() {
      this.loadGigs(1)
    }

    loadGigs(page){
        this.props.templateStore.showLoadingScreen();
        this.props.venueStore.getUserVenues(page).then(() => {
            this.props.venueStore.setPage(page)
            this.props.templateStore.hideLoadingScreen();
        });
    }

    handleShowMore = e => {
        var page = this.props.venueStore.page + 1;
        this.loadGigs(page)
    };
    handleRemove = () => {
        const deletedId = this.state.deletedActId;
        this.props.venueStore.delete(deletedId).then(response => {
            if (this.state.isSearchMode) {
                this.setState({
                    searchResults: this.state.searchResults.filter(v => v.id !== deletedId)
                });
            }
            this.handleCancelDelete();
        });
    };

    handleFilterTextChange = e => {
        this.setState({ filterText: e.target.value });
    };

    handleSearch = () => {
        const { filterText } = this.state;
        if (!filterText || filterText.trim().length === 0) {
            return;
        }
        
        this.setState({ isSearching: true });
        this.props.venueStore.searchVenueAndIndependentVenue(filterText.trim())
            .then(results => {
                this.setState({
                    isSearchMode: true,
                    searchResults: results,
                    isSearching: false
                });
            })
            .catch(error => {
                console.error("Search error:", error);
                this.setState({ isSearching: false });
            });
    };

    handleClearSearch = () => {
        this.setState({
            filterText: "",
            isSearchMode: false,
            searchResults: [],
            isSearching: false
        });
    };

    handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.handleSearch();
        }
    };

    handleCancelDelete = () => {
        this.setState({
            openDeleteConfirmationModal: false,
            deletedActId: undefined
        });
    };

    handleOpenDeleteConfirmation = id => {
        const { isSearchMode, searchResults } = this.state;
        const venueList = isSearchMode ? searchResults : this.props.venueStore.venues.slice();
        const venue = venueList.find(x => x.id === id);
        const venueName = venue ? (venue.profileName || venue.venueName || "") : "";
        this.setState({
            deletedActName: venueName,
            openDeleteConfirmationModal: true,
            deletedActId: id
        });
    };

    closeSnackbarContainer = () => {
        this.setState({
            snackbarMessage: "",
            openSnackbar: false
        });
    };

    handleButtonAdd = () => {
        this.props.profileStore.setStatusCreateVenue(true)
        this.props.profileStore.setVenueNameTitle("Create Venue")
    }

    render() {
        const { venues } = this.props.venueStore;
        const { fullScreen } = false;
        const { isSearchMode, searchResults, isSearching, filterText } = this.state;

        let currentProfile = this.props.profileStore.getCurrentProfile();
        
        let displayVenues = isSearchMode ? searchResults : venues;
        displayVenues = displayVenues.sort((a, b) => {
            const nameA = (a.profileName || a.venueName || "").toUpperCase();
            const nameB = (b.profileName || b.venueName || "").toUpperCase();
            return nameA > nameB ? 1 : -1;
        });

        let renderVenue = venue => {
            const venueName = venue.profileName || venue.venueName || "Unknown Venue";
            const canEdit = venue.canEdit !== false;
            const canRemove = venue.canRemove !== false;
            
            return (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={venue.id}>
                    <Card className="manage-act" raised={false} style={{ boxShadow: "0 1px 1px rgba(0, 0, 0, 0.05)" }}>
                        <div
                            className="act-background-image"
                            style={{
                                backgroundImage: `url(${image.getBackgroundImage(venue)})`
                            }}
                        >
                            <Avatar
                                className="act-avatar"
                                aria-label={venueName}
                                src={image.getProfileImage(venue)}
                            />
                        </div>
                        <CardContent className="act-details">
                            <Typography variant="headline" component="h2">
                                <Link className="act-profile-link" to={"/profile/" + venue.id} target={"_blank"}>
                                    {venueName}
                                </Link>
                            </Typography>
                            <Typography gutterBottom variant="caption">
                                {`${venue.stateEntity ? venue.stateEntity.name + " / " : ""}${venue.region ? venue.region.name : ""}`}
                            </Typography>
                            <Typography className="act-bio" component="div" dangerouslySetInnerHTML={{ __html: venue.bio }} />
                        </CardContent>
                        <Divider />
                        <CardActions className="act-action">
                            {canEdit && (
                                <Button color="default" component={Link} to={`/venues/${venue.id}/edit`} size="small">
                                    Edit
                                </Button>
                            )}
                            <Button
                                color="default"
                                component={Link}
                                to={`/calendar/${venue.id}/venue`}
                                size="small"
                            >
                                Calendar
                            </Button>
                            {canEdit && (
                                <Button
                                    color="default"
                                    size="small"
                                    onClick={this.handleOpenDeleteConfirmation.bind(this, venue.id)}
                                    disabled={!canRemove}
                                >
                                    Remove
                                </Button>
                            )}
                        </CardActions>
                    </Card>
                </Grid>
            );
        };

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="Venues">
                        <TextField
                            className="dark-datepicker"
                            placeholder="Search Venues"
                            onChange={this.handleFilterTextChange}
                            onKeyPress={this.handleKeyPress}
                            value={filterText}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {isSearching ? (
                                            <CircularProgress size={20} />
                                        ) : (
                                            <SearchIcon />
                                        )}
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Button
                            style={{ marginLeft: 8, color: 'white' }}
                            color="primary"
                            variant="contained"
                            onClick={this.handleSearch}
                            disabled={isSearching || !filterText.trim()}
                        >
                            Search
                        </Button>
                        {isSearchMode && (
                            <Button
                                style={{ marginLeft: 8, color: '#bbb', borderColor: '#888' }}
                                variant="outlined"
                                onClick={this.handleClearSearch}
                            >
                                Clear
                            </Button>
                        )}

                        {
                            (!currentProfile?.hasOrganisation) ? 
                            (
                                (venues.length == 0 || venues.length  < currentProfile?.maxVenueLimit) ?
                                (
                                    <Button classes={{ root: "pull-right" }} style={{marginLeft: 20, color: 'white'}} color="primary" variant="contained" component={Link} to="/venues/new" onClick={this.handleButtonAdd}>
                                        Add Venue
                                    </Button>
                                )
                                :
                                (
                                    <Button disabled classes={{ root: "pull-right" }} style={{marginLeft: 20, color: 'grey'}} color="primary" variant="contained" component={Link} to="/venues/new" onClick={this.handleButtonAdd}>
                                        Add Venue
                                    </Button>
                                )
                            )
                            :
                            (
                                
                                    !(currentProfile?.viewOnly) && (currentProfile?.allowBooking) && (currentProfile?.editVenue) ? 
                                    (
                                        <Button classes={{ root: "pull-right" }} style={{marginLeft: 20, color: 'white'}} color="primary" variant="contained" component={Link} to="/venues/new" onClick={this.handleButtonAdd}>
                                            Add Venue
                                        </Button>
                                    )
                                    :
                                    ""
                                
                            )
                        }
                    </Heading>
                    
                    {isSearchMode && (
                        <Typography variant="body1" style={{ marginBottom: 16, color: '#aaa' }}>
                            Found {searchResults.length} venue{searchResults.length !== 1 ? 's' : ''} matching "{filterText}"
                        </Typography>
                    )}
                    
                    <Grid container direction="column" spacing={8}>
                        <Grid item xs={12}>
                            <Grid container spacing={8}>
                                {displayVenues.map(venue => renderVenue(venue))}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                            <Grid container direction="row" justify="center" alignItems="center">
                            {!isSearchMode && this.props.venueStore.isMore ? (
                                    <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                        Show More
                                    </Button>
                                ) : null}
                            </Grid>
                        </Grid>

                        <Dialog
                            fullScreen={fullScreen}
                            open={this.state.openDeleteConfirmationModal}
                            onClose={this.handleCancelDelete}
                            aria-labelledby="responsive-dialog-title"
                        >
                            <DialogTitle id="responsive-dialog-title">Delete Venue</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure to delete <strong>{this.state.deletedActName}</strong>?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCancelDelete} color="primary">
                                    Close
                                </Button>
                                <Button onClick={this.handleRemove} color="primary" autoFocus>
                                    Delete
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            open={this.state.openSnackbar}
                            onClose={this.closeSnackbarContainer}
                            autoHideDuration={6000}
                            SnackbarContentProps={{
                                "aria-describedby": "message-id"
                            }}
                            message={<span id="message-id">{this.state.snackbarMessage}</span>}
                            action={[
                                <IconButton key="close" aria-label="Close" color="inherit" onClick={() => this.closeSnackbarContainer()}>
                                    <ClearIcon />
                                </IconButton>
                            ]}
                        />
                    </Grid>
                </MainContainer>
            </main>
        );
    }
}

export default Venues;
